export const FormConstants = {
    FORM_INFORMATION: {
        TITLE: 'GENERAL INFORMATION',
        LOCATION: [
            {
                PLACE: "📍Fresh Linen Launders - Velachery Store",
                ADDRESSLINE_1: "Old No. 52D, New No. 157/2, Velachery Main Road",
                ADDRESSLINE_2: "Guru Nanak Road, Velachery, Chennai-600042",
                PHONE: "+(91) 917 640 2233",
                GMAP: "https://www.google.com/maps/place/Fresh+Linen+Launders/@12.9843881,80.2206318,17z/data=!3m1!4b1!4m5!3m4!1s0x3a525db7af932725:0xc7c5007a26d61aa4!8m2!3d12.9843829!4d80.2228205",
                TIMINGS: "10AM - 7PM"
            },
            {
                PLACE: "📍Fresh Linen Launders - Anna Nagar Store",
                ADDRESSLINE_1: "No.5, D Block, 126 1st Main Road",
                ADDRESSLINE_2: "Anna Nagar East, Chennai-600102",
                PHONE: "+(91) 917 640 4433",
                GMAP: "https://maps.app.goo.gl/CV4Hsm9M9n6ffNK36",
                TIMINGS: "10AM - 7PM"
            }
        ],
        FORM_INPUT: {
            FORM_TITLE: 'HAVE QUESTIONS❓GET IN TOUCH!',
            FORM_INPUT_FIELDS: [
                'First Name',
                'Last Name',
                'Phone',
                'Email',
                'Message'
            ],
            STORES: ["Velachery", "Anna Nagar"],
        }
    }
}